import { SfdcDisplayType } from '../../../types/fields';
import { SimpleFieldSelector, SimpleFieldSelectorProps } from './SimpleFieldSelector';

type LeadingFieldSelectorProps = Omit<
  SimpleFieldSelectorProps,
  'groupByLeadingCandidates' | 'autoSelectDefaultFieldForObjectType'
>;

const excludeCompoundFieldsFilterAndNonPicklist = (field: SweepField) =>
  field.sfDisplayType === SfdcDisplayType.PICKLIST && !field.isCompound;

export const LeadingFieldSelector = (props: LeadingFieldSelectorProps) => {
  return (
    <SimpleFieldSelector
      {...props}
      groupByLeadingCandidates
      showApiNameTooltip
      autoSelectDefaultFieldForObjectType
      filterBy={excludeCompoundFieldsFilterAndNonPicklist}
    />
  );
};
